import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderEnding'
})
export class OrderEndingPipe implements PipeTransform {

  transform(order: 'Order'|'Заказ', count: number): string {
    if (order === 'Заказ') {
      return this.getPropterEnding(count, ['Заказ', 'Заказа', 'Заказов']);
    }
    return count === 1 ? 'Order' : 'Orders';
  }

  getPropterEnding(count: number, titles: string[]): string {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (count % 100 > 4 && count % 100 < 20) ? 2 : cases[(count % 10 < 5) ? count % 10 : 5]];
  }
}
